import Telemetry from '@atlassian/mpac-telemetry';
import { connect } from 'react-redux';

import commonMapStateToProps from 'app/container/commonMapStateToProps';
import headerCommonMapDispatchToProps from 'common/components/Header/container/headerCommonMapDispatchToProps';
import * as aceAnalytics from 'common/utils/analytics/aceAnalytics';
import * as analytics from 'common/utils/analytics/analytics';
import { openSubscribeDialog as openMailingListSubscribeDialog } from '../../../../common/SubscribeMailingListDialog/action/SubscribeMailingListActions';
import RouteContainer from '../components/RouteContainer';

function mapStateToProps(state: any) {
  return {
    ...commonMapStateToProps(state),
    addonDiscoveryConfig: state.addonDiscovery.config,
    collectionsConfig: state.collections.config,
    displayGeneralTextSearch: state.app.displayGeneralTextSearch,
    displayPartnerQuickLinks: state.app.displayPartnerQuickLinks,
    displayCollectionsFooter: state.app.displayCollectionsFooter,
    user: state.user,
    solutionsConfig: state.solutions.config,
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    ...headerCommonMapDispatchToProps(dispatch),
    openMailingListSubscribeDialog: () => dispatch(openMailingListSubscribeDialog()),
    onRouteChange: ({ pathname, search, name, referrer, suppressPageView, isInitial }) => {
      if (!isInitial) {
        Telemetry.routeChangeStart();
      }

      if (!suppressPageView) {
        // @ts-expect-error [MC-2850] - TS2554 - Expected 2 arguments, but got 1.
        analytics.trackPageView(`${pathname}${search}`);
        aceAnalytics.trackPageView(referrer, name, {
          poweredBy: 'AMKT_FRONTEND',
        });
      }
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RouteContainer);
